export const config = {
    spinnerTimeout: 90000 // Timeout to auto hide the Global Spinner, Default 1.5min
};
